import React, { useState } from "react";
import Filter from './components/Filter'
import HotelLists from "./components/HotelLists";
import useFetch from "../../commons/useFetch";
function Hotel(){
    const [destinations, setDestinations] = useState();
    const [check, setCheck] = useState(false);

    function Destinations(value) {
      setDestinations(value);
      setCheck(true);
    }

    const {data : hotels}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels')

    return (
      <div className="container">
        <Filter onChangeHotels={Destinations} />
        {hotels && <HotelLists hotels={hotels} destinations={destinations} check={check}/>}
      </div>
    );
}
export default Hotel;